export function num(value, max = true) {
  return (max ? Math.max(value, 0) : value).toFixed(0)
}

export function cond(condition, value) {
  return condition === true ? value : ''
}
